import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowUpIcon from '@/assets/icons/arrow-up.svg?react';
import { hexToRgba } from '@/utils';

export const IconButton = styled(ArrowUpIcon)`
  position: absolute;
  fill: ${({ theme }) => theme?.colors?.light};
`;

export const Button = styled.button<{ isEmbedded?: boolean }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 34px;
  height: ${({ isEmbedded }) => (isEmbedded ? '34px' : '100%')};
  padding: 0;
  font-size: 24px;
  overflow: hidden;
  border: none;
  background: #000;
  transition: all 0.2s ease;

  /* need to style button and arrow on Safari (IOS) */
  &,
  &:enabled {
    color: #fff;
    cursor: pointer;
    border-radius: ${({ isEmbedded, theme }) => {
      if (isEmbedded) {
        return '50%';
      }
      return theme.isRtl ? '6px 0 0 6px' : '0 6px 6px 0';
    }};
    background: #000;
  }

  &:disabled {
    cursor: not-allowed;

    /* required to style an arrow on Safari (IOS) */
    background-color: #6c6c6c;

    svg {
      fill: ${({ theme }) => hexToRgba(theme?.colors?.light ?? '#fff', 0.6)};
    }
  }

  ${({ theme }) => css`
    ${theme?.sendButton?.styles}

    @media (${theme.mediaMobile}) {
      ${theme?.sendButton?.mobile}
    }

    @media not (${theme.mediaMobile}) {
      ${theme?.sendButton?.desktop}
    }
  `}

  ${({ theme }) => theme?.sendButton};
`;
